export default __webpack_public_path__ + "static/media/rolar-pagina-para-o-topo-icon.e3e9c233.svg";